import { render, staticRenderFns } from "./battery-icon.vue?vue&type=template&id=0f57b791"
import script from "./battery-icon.vue?vue&type=script&lang=js"
export * from "./battery-icon.vue?vue&type=script&lang=js"
import style0 from "./battery-icon.vue?vue&type=style&index=0&id=0f57b791&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports